import { useId, type ReactElement, type ReactNode } from 'react';
import { Button } from '@ff-it/ui';
import * as styles from './SectionCard.css';

type SectionCardProps = {
  title: ReactNode;
  expanded: boolean;
  renderAction?: (contentId: string) => ReactNode;
  onToggle?: () => void;
  children: ReactNode;
};

export function SectionCard({ title, expanded, renderAction, onToggle, children }: SectionCardProps): ReactElement {
  const panelId = useId();
  return (
    <div className={styles.card}>
      {onToggle ? (
        <Button
          type="button"
          variant="secondary"
          active={expanded}
          iconAfter={`chevron-${expanded ? 'up' : 'down'}`}
          className={styles.toggleHeader}
          data-active={expanded}
          aria-expanded={expanded}
          aria-controls={panelId}
          onClick={onToggle}
        >
          {title}
        </Button>
      ) : (
        <div className={styles.header} data-active={expanded}>
          <span className={styles.title}>{title}</span>
          {renderAction?.(panelId)}
        </div>
      )}
      <div id={panelId} hidden={!expanded}>
        {expanded && children}
      </div>
    </div>
  );
}
